module.exports = __webpack_public_path__ + "img/mapPlaceHolder.11414cb1.png";